module.exports = {"order":0,"item":"ats","size":{"sm":12,"md":6,"lg":6,"xl":3},"data":{"name":"Ats","desc":"INFORMATION","position":{"name":"Position","visibility":true,"tag":{"id":"0","text":"noTag"},"tagBit":{"id":"99","text":"noBit"},"tagEmergency":{"id":"0","text":"noTag"},"tagBitEmergency":{"id":"99","text":"noBit"},"boolConfig":{"trueMsg":"Closed","trueColor":{"id":"danger","text":"Danger"},"falseMsg":"Open","falseColor":{"id":"success","text":"Success"}}}}}


//////////////////
// WEBPACK FOOTER
// ./src/views/site/Developer/DeveloperOverviewRender/Components/Data/Ats.json
// module id = 354
// module chunks = 0